import React, { memo } from 'react'
import SignIn from '../SignIn'
import SignedIn from '../SignedIn'
import useSSO from '../../hooks/useSSO'
import useLogin from '../../hooks/useLogin'
import useLogout from '../../hooks/useLogout'

function Account () {
  const { isEnabled, isSignedIn, handleSignOut, ...props } = useSSO()
  const { onLoginClick } = useLogin({
    session: typeof window === 'object' && window.location.href
  })
  const { onLogoutClick } = useLogout()

  const Component = isSignedIn ? SignedIn : SignIn

  return isEnabled ? (
    <Component
      {...props}
      onLoginClicked={onLoginClick}
      onLogoutClicked={() => handleSignOut(onLogoutClick)}
    />
  ) : null
}

Account.displayName = 'Account'

export default memo(Account)
